import React from 'react';
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, Snackbar, Stack, Alert, Tooltip} from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import {MetaTags} from 'react-meta-tags';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from '@mui/material/FormControl'; 
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import DialogTestStart from '../components/DialogTestStart';
import TreeViewCards from '../components/TreeViewCardsV2';
import BreadcrumbsInc from '../components/BreadcrumbsInc';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import TreeViewComp from '../components/TreeViewComp';
///import SearchInput from '../components/SearchInput';
import SearchInputA from '../components/SearchInputA';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy"; 
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import SelfTestInfo from "../components/SelfTestInfo";
import '../styles/bizofficer-a.css';
import BottomDrawer from '../components/BottomDrawer/BottomDrawer';
import { useDispatch, useSelector } from 'react-redux';
///import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';
import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setLearningContents, setTopicTreeTest, setTopicListTest, setMockTest, setContentLimit } from '../store/data.actions';
import TutorialButton from '../components/StudentTutorial/StudentTutorial';
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial';
import Cookies from "js-cookie";
import StudyMaterialHelpVideoButton from '../components/StudyMaterialHelpVideoButton/StudyMaterialHelpVideoButton';
//import { setPopup } from '../store/popup.actions';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  
  export default function Execute() {	
	const dataObj = useSelector(state => state.getData);
	 const popup1 = useSelector((state => state?.popup1))
	const dispatch = useDispatch();
	const classes = useStyles();
	let history = useHistory();
	const ftue = Cookies.get("ftue");
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	
	///const [showProgress, setShowProgress] = React.useState(false);

	const [organisationName, setOrganisationName] = React.useState("");
  	const [validityExpired, setValidityExpired] = React.useState(false);

	const [progressBar, setProgressBar] = React.useState(0);
	const [progressBarFlag, setProgressBarFlag] = React.useState(0);
	const [progressBarColor, setProgressBarColor] = React.useState('red');
	const [progressBarRemarks, setProgressBarRemarks] = React.useState('');
	const [selfAssessorFormType, setSelfAssessorFormType] = React.useState('beginner');
	const [examType, setExamType] = React.useState("objective");
	const [topicObj, setTopicObj] = React.useState({});
	const [cardsTopicObj, setCardsTopicObj] = React.useState({});
	///const [topicList, setTopicList] = React.useState([]);
	///const [keywordList, setKeywordList] = React.useState([]);
	//const [topicsTree, setTopicsTree] = React.useState([]);

	const childRefStartTest = React.useRef();  
	const [selftTestOptions, setSelftTestOptions] = React.useState([]);
	const [selftTestOptionIndex, setSelftTestOptionIndex] = React.useState(0);

	// const [questionTypeList, setQuestionTypeList] = React.useState([]);
	const [totalQuestion, setTotalQuestion] = React.useState(20);
	const [totalQuestionKwd, setTotalQuestionKwd] = React.useState(5);
	const [totalTime, setTotalTime] = React.useState(60);
	const [marksCorrectAnswer, setMarksCorrectAnswer] = React.useState(1);
	const [marksIncorrectAnswer, setMarksIncorrectAnswer] = React.useState(0);
	const [marksNotAttempted, setMarksNotAttempted] = React.useState(0);
	// const [examTypeList, setExamTypeList] = React.useState([]);

	const [selectedTopicId, setSelectedTopicId] = React.useState(0);
	const [searchQuery, setSearchQuery] = React.useState(null);
	const [searchFlag, setSearchFlag] = React.useState("Topic");
	const [availableTotalQuestion, setAvailableTotalQuestion] = React.useState(0);
	const [questionType, setQuestionType] = React.useState("Any");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [currentRunningTestTitle, setCurrentRunningTestTitle] = React.useState("");
	const [currentRunningTestSession, setCurrentRunningTestSession] = React.useState("");
	const [testType, setTestType] = React.useState(1);
	const [currentRunningSelfTestType, setCurrentRunningSelfTestType] = React.useState('beginner');

		// Help Video Icon State
	const [isHelpVideoOpen, setIsHelpVideoOpen] = React.useState(false);
	///const [selectedTemplateId, setSelectedTemplateId] = React.useState(0);

	// const [topicListView, setTopicListView] = React.useState([]);
	// const [breadcrumbs, setBreadcrumbs] = React.useState([]);
	// const [breadcrumbsObjArr, setBreadcrumbsObjArr] = React.useState([]);
	// const [bCIndexArr, setBCIndexArr] = React.useState([]);
	const [smTab, setSmTab] = React.useState(2);
	const [showProgress, setShowProgress] = React.useState(false);
	///const myURRL = "selfassessor";
	const authResult = new URLSearchParams(window.location.search);
	const gotab = authResult.get('gotab');

	

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		history.push('login');
	}

	const vertical='top',horizontal='center';

	const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
		height: 10,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
		  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
		},
		[`& .${linearProgressClasses.bar}`]: {
		  borderRadius: 5,
		  backgroundColor: theme.palette.mode === 'light' ? progressBarColor : '#308fe8',
		},
	  }));  
	//#2b568d
	
	const handleSelfAssessorFormType = (event, newValue) => {
		setSelfAssessorFormType(newValue);
		localStorage.setItem('selfAssessorFormType', newValue);
	};

	React.useEffect(() => {
		if(gotab && gotab.length>0){
			localStorage.setItem('selfAssessorFormType', gotab);
			setSelfAssessorFormType(gotab);
		}
	}, [gotab]);

	React.useEffect(() => {
		if(localStorage.getItem('selfAssessorFormType')){
			setSelfAssessorFormType(localStorage.getItem('selfAssessorFormType'));		
		}else{
			localStorage.setItem('selfAssessorFormType', 'beginner');
			setSelfAssessorFormType('beginner');
		}
	}, [localStorage.getItem('selfAssessorFormType')]);
	
	const selectTopic = (obj) => {		
		setTopicObj(obj);
		setSearchFlag('Topic');
		setSearchQuery(obj.topicName);
		setSelectedTopicId(obj.topicId);
		if(examType==='subjective'){
			setAvailableTotalQuestion(obj.subjectiveCount);			
		}else{
			setAvailableTotalQuestion(obj.questionCount);
		}
		if(obj.children && obj.children.length && obj.children.length>0){
			setCardsTopicObj(obj);
		}
	}

	const searchBoxQuery = (searchFlag,obj) => {
		setTopicObj(obj);
		setSearchFlag(searchFlag);
		setSearchQuery(obj.title);
		setSelectedTopicId(obj.id);
		if(examType==='subjective'){
			setAvailableTotalQuestion(obj.subjectiveCount);			
		}else{
			setAvailableTotalQuestion(obj.questionCount);
		}
	}

	const searchBoxQueryKeyword = (searchFlag,obj) => {
		setTopicObj(obj);
		setSearchFlag(searchFlag);
		setSearchQuery(obj.title);
		setSelectedTopicId(obj.id);
		setAvailableTotalQuestion(1);
		setSelfAssessorFormType('beginner');
		localStorage.setItem('selfAssessorFormType', 'beginner');
		setExamType("objective");
	}

	const selectTopicCard = (obj) => {
		if(obj && obj.topicId>0){
			setTopicObj(obj);
			setSearchFlag('Topic');
			setSearchQuery(obj.topicName);
			setSelectedTopicId(obj.topicId);
			if(examType==='subjective'){
				setAvailableTotalQuestion(obj.subjectiveCount);			
			}else{
				setAvailableTotalQuestion(obj.questionCount);
			}
			if(obj.children && obj.children.length && obj.children.length>0){
				setCardsTopicObj(obj);
			}	
		}else{
			setCardsTopicObj({});

		}
	}

	function handleSelftTestOption(i) {
		if(i){
			setSelftTestOptionIndex(i);
			if(selftTestOptions && selftTestOptions[i] && selftTestOptions[i].questionTypeList[0]){
				setQuestionType(selftTestOptions[i].questionTypeList[0].typeTitle);
			}
			setExamType(selftTestOptions[i].examType);
			setTotalQuestion(selftTestOptions[i].totalQuestions);
			setTotalQuestionKwd(selftTestOptions[i].totalQuestionsKwd);
			setTotalTime(selftTestOptions[i].duration);
			setMarksCorrectAnswer(selftTestOptions[i].marksCorrectAns);
			setMarksIncorrectAnswer(selftTestOptions[i].marksIncorrectAns);
			setMarksNotAttempted(selftTestOptions[i].marksNotAnswer);
			if(selftTestOptions[i].examType==='subjective'){
				setAvailableTotalQuestion(topicObj.subjectiveCount);			
			}else{
				setAvailableTotalQuestion(topicObj.questionCount);
			}	
		}
	}

	function startMyTest(){
		///alert("aaaa");
		if(!searchQuery){
			setShowAlert(true);
			setAlertMessage("Select your topic");
		}else{
			///alert("bbbbb");
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
				//alert("ccccccc");
			// axios.get(API_URL+'/testcurrentrunning?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
			// window.location.href='testsimulatorone?testType=7&questionType='+quesType+'&totalQuestion='+totalQuestionz+'&totalTime='+totalTime+'&marksCorrectAnswer='+marksCorrectAnswer+'&marksIncorrectAnswer='+marksIncorrectAnswer+'&marksNotAttempted='+marksNotAttempted+'&searchFlag='+searchFlag+'&searchQuery='+searchQuery+'&topicId='+selectedTopicId+'&examType='+examType;
			axios.get(API_URL+'/adaptive-create-test?templateId='+mySelectedCourses[selectedCourse].templateId+'&courseId='+mySelectedCourses[selectedCourse].courseId+'&topicId='+selectedTopicId, axiosHeader)
				.then(response => {
					//alert("ddddd");
					if(response.data.responseTxt==="found-incomplete-test"){
						//alert("eeeee");
						setCurrentRunningTestTitle(response.data.obj.testName);
						setCurrentRunningTestSession(response.data.obj.testSession);
						setTestType(response.data.obj.testType);
						// if(response.data.testType===1 && response.data.testMode==='Competitive Session'){
						// 	setCurrentRunningSelfTestType('advance');
						// }else if(response.data.testType===1){
						// 	setCurrentRunningSelfTestType('beginner');
						// }else{
						// 	setCurrentRunningSelfTestType(null);
						// }
						childRefStartTest.current.handleClickOpen();
					}else if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear(); 
						history.push('logout');
											
					}else if(response.data.responseTxt==="success" && searchQuery){
						// let quesType="";
						// if(selftTestOptions && selftTestOptions[selftTestOptionIndex] && selftTestOptions[selftTestOptionIndex].questionTypeList){
						// 	for(let i=0; i<selftTestOptions[selftTestOptionIndex].questionTypeList.length; i++){
						// 		quesType+=selftTestOptions[selftTestOptionIndex].questionTypeList[i].typeTitle+",";
						// 	}
						// 	if(quesType && quesType.length>0){
						// 		quesType = quesType.substring(0,quesType.length-1)
						// 	}
						// }else if(questionType){
						// 	quesType = questionType;
						// }

						// let totalQuestionz = totalQuestion;
						// if(searchFlag && searchFlag==='Keyword'){
						// 	totalQuestionz = totalQuestionKwd;
						// }
						//alert("fffff");
						window.location.href='testsimulatorone?testSession='+response.data.obj.testSession;

						// window.location.href='testsimulatorone?testType=7&questionType='+quesType+'&totalQuestion='+totalQuestionz+'&totalTime='+totalTime+'&marksCorrectAnswer='+marksCorrectAnswer+'&marksIncorrectAnswer='+marksIncorrectAnswer+'&marksNotAttempted='+marksNotAttempted+'&searchFlag='+searchFlag+'&searchQuery='+searchQuery+'&topicId='+selectedTopicId+'&examType='+examType;
					
					}else{
						//alert("jjjjj");
						setShowAlert(true);
						setAlertMessage("Select your topic");
					}
					
					//alert("XXXXX");
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}	
	}
	function deleteCurrentStartNew(){	
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};	
		axios.get(API_URL+'/testrunningdelete?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
			   .then(response => {
			 	///console.log("Just Checking >> "+response.data);
				if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
				}			 				
		}).catch((error) => {
			console.log("AXIOS ERROR: ", error);
		})

		setTimeout(function() {
  			//Create Test......		
			startMyTest();
		}, 3000);
		
		///window.location.href='testsimulator?testId=0&testType=1&questionType='+questionType+'&totalQuestion='+totalQuestion+'&totalTime='+totalTime+'&marksCorrectAnswer='+marksCorrectAnswer+'&marksIncorrectAnswer='+marksIncorrectAnswer+'&marksNotAttempted='+marksNotAttempted+'&searchFlag='+searchFlag+'&searchQuery='+searchQuery+'&topicId='+selectedTopicId+'&assessmentMode='+selfAssessorFormType;
	}	
	function continueCurrentTest(){	
		// const crstt = currentRunningSelfTestType?'&assessmentMode='+currentRunningSelfTestType:'';
		// window.location.href='testsimulatorone?testSession='+currentRunningTestSession+'&testType='+testType+crstt;
		window.location.href='testsimulatorone?testSession='+currentRunningTestSession;

	}

	function hideAlert(){
		setShowAlert(false);
	}

	React.useEffect(() => {		
		if(selectedCourse && selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId && mySelectedCourses[selectedCourse].courseId && mySelectedCourses[selectedCourse].selfTest==1){

			getApiData(mySelectedCourses[selectedCourse].templateId);
			////alert(mySelectedCourses[selectedCourse].templateId)
			let diffDays = 0;
			if(localStorage.getItem('cacheDate')){
				let date1 = new Date(localStorage.getItem('cacheDate'));								
				let date2 = new Date();
				let diffTime = date2.getTime() - date1.getTime();
				diffDays = Math.round(diffTime / (1000 * 3600 * 24));
			}
			if(diffDays>0 || localStorage.getItem('templateId')!=mySelectedCourses[selectedCourse].templateId){
				getApiDataCourse(mySelectedCourses[selectedCourse].templateId);
			}	

			// Check validity ************************************
			setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
			var d1 = new Date();
			var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
			d2.setDate(d2.getDate() + 1);
			if(d1>d2 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")===-1){
				setValidityExpired(true);      
			}else{
				setValidityExpired(false);
			}

		}
	}, [selectedCourse]); 

	async function getApiData(templateId){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};

			axios.get(API_URL+'/selftestformoptions?templateId='+templateId, axiosHeader)
			   .then(response => {
			 	 ///console.log("Just Checking >> "+JSON.stringify(response.data));  
				 if(response && response.status===200 && response.data.responseTxt==="success"){
					//document.write(JSON.stringify(response.data.obj));
					setSelftTestOptions(response.data.obj);
					setSelftTestOptionIndex(0);
					setTotalQuestion(response.data.obj[0].totalQuestions);
					setTotalQuestionKwd(response.data.obj[0].totalQuestionsKwd);
					setTotalTime(response.data.obj[0].duration);
					setMarksCorrectAnswer(response.data.obj[0].marksCorrectAns);
					setMarksIncorrectAnswer(response.data.obj[0].marksIncorrectAns);
					setMarksNotAttempted(response.data.obj[0].marksNotAnswer);	
					setExamType(response.data.obj[0].examType);

					if(response.data.obj && response.data.obj[0] && response.data.obj[0].questionTypeList){
						setQuestionType(response.data.obj[0].questionTypeList[0].typeTitle);
					}

				}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
									
				}

			})
	}

	async function getApiDataCourse(tempId){
		setShowProgress(true);		
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		///tempId = 40;
		axios.get(API_URL+'/templatecache-section?templateId='+tempId, axiosHeader)
		   .then(response => {

			if(response.data && response.data.responseTxt==='success'){				
				setShowProgress(false);

				localStorage.setItem("templateId", tempId);
				localStorage.setItem("cacheDate", new Date());

				//*********************************
				if(response.data.topicTree && response.data.topicTree.length>0){
					///document.write(response.data.topicTree);
					dispatch(setTopicTree(JSON.parse(response.data.topicTree)));
				}else{
					dispatch(setTopicTree([]));
				}
				if(response.data.topicList && response.data.topicList.length>0){
					dispatch(setTopicList(JSON.parse(response.data.topicList)));
				}else{
					dispatch(setTopicList([]));
				}
				if(response.data.keywordList && response.data.keywordList.length>0){
					dispatch(setKeywordList(JSON.parse(response.data.keywordList)));
				}else{
					dispatch(setKeywordList([]));
				}
				if(response.data.smartLearningJson && response.data.smartLearningJson.length>0){
					dispatch(setLearningContents(JSON.parse(response.data.smartLearningJson)));
				}else{
					dispatch(setLearningContents([]));
				}
				if(response.data.topicTreeLearning && response.data.topicTreeLearning.length>0){
					dispatch(setTopicTreeLearning(JSON.parse(response.data.topicTreeLearning)));
				}else{
					dispatch(setTopicTreeLearning([]));
				}
				if(response.data.topicListLearning && response.data.topicListLearning.length>0){
					dispatch(setTopicListLearning(JSON.parse(response.data.topicListLearning)));
				}else{
					dispatch(setTopicListLearning([]));
				}
				if(response.data.keywordListLearning && response.data.keywordListLearning.length>0){
					dispatch(setKeywordListLearning(JSON.parse(response.data.keywordListLearning)));
				}else{
					dispatch(setKeywordListLearning([]));
				}
				if(response.data.topicTreeTest && response.data.topicTreeTest.length>0){
					dispatch(setTopicTreeTest(JSON.parse(response.data.topicTreeTest)));
				}else{
					dispatch(setTopicTreeTest([]));
				}
				if(response.data.topicListTest && response.data.topicListTest.length>0){
					dispatch(setTopicListTest(JSON.parse(response.data.topicListTest)));
				}else{
					dispatch(setTopicListTest([]));
				}
				if(response.data.mockTestJson && response.data.mockTestJson.length>0){
					dispatch(setMockTest(JSON.parse(response.data.mockTestJson)));
				}else{
					dispatch(setMockTest([]));
				}

				if(response.data.contentLimit){
					dispatch(setContentLimit(response.data.contentLimit));
				}else{
					dispatch(setContentLimit({}));
				}

			
		    }else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.clear(); 
					history.push('logout');
			
			} 
		})
	}

	React.useEffect(() => {
		if(searchQuery && searchQuery.length>0 && selfAssessorFormType){
			getApiDataGetLastTest(searchQuery);
		}
	}, [searchQuery, selfAssessorFormType]);

	async function getApiDataGetLastTest(topicName){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};	 
		let testMode="";
		if(selfAssessorFormType && selfAssessorFormType==='advance'){
			testMode="Competitive Session";
		}else{
			testMode="Learning Session";
		}
		axios.get(API_URL+'/last-self-test-percentage?templateId='+mySelectedCourses[selectedCourse].templateId+'&testType=1&testMode='+testMode+'&topicName='+topicName, axiosHeader)
		   .then(response => {
			if(response.data && response.data.responseTxt==='success' && response.data.obj && response.data.obj.percentage){
				setProgressBar(response.data.obj.percentage);	
				setProgressBarFlag(1);		
				setProgressBarColor(response.data.obj.barColor);
				
				setProgressBarRemarks('');
				if(selfAssessorFormType && selfAssessorFormType==='beginner'){
					if(response.data.obj.barColor==='green'){
						setProgressBarRemarks('Well done. Move to competitive mode');
					}else if(response.data.obj.barColor==='orange'){
						setProgressBarRemarks('Good progress but still continue learning');
					}else{
						setProgressBarRemarks('Not upto mark. Continue learning');
					}
				}
		    }else{
				setProgressBar(0);	
				setProgressBarFlag(0);
			}
		})
	}

	function upgradeNow(){
		if(mySelectedCourses && selectedCourse>-1){
		  window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
		}
  	}
	
  	React.useEffect(() => {
		if(localStorage.getItem('smTab')){
			setSmTab(localStorage.getItem('smTab'));
		}
	}, [localStorage.getItem('smTab')]);

	const handleChangeTabs = (val) => {
		setSmTab(val);
		localStorage.setItem('smTab',val);
	};

	
		return (
			<div> 
				<MetaTags>
            		<title>Adaptive Learning</title>
          		</MetaTags>
				
				  <Header />	
	   			  <LeftDrawer />
      			<main className={classes.content}>
				<NotificationAlerts />
        		{/* {JSON.stringify(dataObj.topicTree)} */}
				{showProgress?<LinearProgress />:null}
				<Box style={{marginLeft:10, marginRight:10}}>
					<Box mt={1}>
						<Grid container spacing={2} >
							<Grid item md={9} xs={12} style={window.screen.width>480?{backgroundColor:'#f5f5fb', minHeight:'85vh', borderRadius:10}:{backgroundColor:'#f5f5fb', minHeight:'120vh', borderRadius:10}} >

							{(dataObj.keywordList && dataObj.keywordList.length>3)?	
								<div style={{marginTop:5}}>
									<SearchInputA options={dataObj.keywordList} label="Search Keyword" flag="Keyword" toCallParentMethod={searchBoxQueryKeyword} />
								</div>
							:null}	

							{(dataObj.topicList && dataObj.topicList.length>3)?
								<div style={{marginTop:12}}>
									<SearchInputA options={dataObj.topicList} label="Search Topic" flag="Topic" toCallParentMethod={searchBoxQuery} />
								</div>
							:null}

								<Box mt={1}>
									<Grid container spacing={2}>
										<Grid item md={6} xs={8}>
											<h3 className="heading items_center" ><i className='fa fa-magic' ></i> Adaptive Learning
											<StudyMaterialHelpVideoButton
											state={isHelpVideoOpen} 
											stateHandler={setIsHelpVideoOpen}
											title={"What is MY Study Room and how to use it?"}
											link={"https://www.youtube.com/embed/PBZ_v7gVBXI?si=JKUzsldGRRdmPviL"} />
											</h3>
										</Grid>
										<Grid item md={6} xs={4} >
											<div style={{textAlign:'right'}}>
												<Tooltip title="List View" ><GridViewIcon onClick={()=>{handleChangeTabs(1)}} style={smTab==1?{color:'#000000',cursor:'pointer',border:'1px solid #000',marginRight:2,backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede',marginRight:2}} /></Tooltip> 
												<Tooltip title="Tree View" ><AccountTreeIcon onClick={()=>{handleChangeTabs(2)}} style={smTab==2?{color:'#000000',cursor:'pointer',border:'1px solid #000',backgroundColor:'#eae8e8'}:{color:'#CCCCCC',cursor:'pointer',border:'1px solid #e0dede'}} /></Tooltip>
											</div>
										</Grid>
									</Grid>
								</Box>	
								<Box mt={1} >
									{smTab==2?<>
										{showProgress?<span><CircularProgress size={20} /> Loading...</span>:
										<>
											<p className="headingTwo" style={{marginTop:10}}>Browse Topic & Select</p>
											<TreeViewComp treeViewData={dataObj.topicTree} toCallParentMethod={selectTopic} />
										</>}		
									</>	
									:<>
										{showProgress?<span><CircularProgress size={20} /> Loading...</span>:
										<>
											<BreadcrumbsInc topicTree={dataObj.topicTree} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
											<TreeViewCards topicTree={dataObj.topicTree} topicObj={cardsTopicObj} selectTopic={selectTopicCard} />
										</>}
									</>	
									}
								</Box>

							</Grid>
							{window.screen.width>480?
							<Grid item md={3} xs={12}>
								<Box style={{marginLeft:7}} >
									<Box>
										<Grid container spacing={2} className="btmbdrgry" >
											<Grid item xs={12} >
												<span style={{fontWeight:'bold'}} >{searchQuery?<span>{searchQuery}</span>:<span style={{color:'red'}} >Select topic to begin</span>}</span>
											</Grid>
										</Grid>
									</Box>
									<Box mt={1} className="student_panel_desktop_display" >
										<Box mt={1} className="selfTestForm animate-zoom" >
											<Box style={{fontWeight:'bold', color: '#1f407a', textAlign:'center', fontSize: 12}} >
												FASTEST method of learning <SelfTestInfo />
											</Box>
											{/* {(searchFlag==='Topic' && selftTestOptions && selftTestOptions.length>1)?
											<Box mt={1} >	
													<Grid container spacing={2}>
														<Grid item md={12} xs={12}>	
																<TextField
																	fullWidth
																	id="outlined-select-native"
																	select
																	label="Assessment Type"
																	value={selftTestOptionIndex}
																	onChange={(event)=>{handleSelftTestOption(event.target.value)}}
																	SelectProps={{
																		native: true,
																	}}	
																	size='small'		
																	style={{fontSize:12}}	
																>
																	{selftTestOptions.map((row,i)=>(
																		<option key={'a'+i} value={i} >{row.examType}</option>
																	))}
																</TextField>
														</Grid>
													</Grid>
											</Box>
											:null} */}

										{/* {searchFlag==='Topic'?	
											<Box sx={{ width: '100%', bgcolor: 'background.paper' }} >
												<Stack spacing={2} alignItems="center">
												<ToggleButtonGroup
													color="primary"
													value={selfAssessorFormType}
													exclusive
													onChange={handleSelfAssessorFormType}
													aria-label="Platform"
													>
													<ToggleButton value="beginner" disabled={selfAssessorFormType==='beginner'} style={selfAssessorFormType==='beginner'?{height:25, backgroundColor:'#f09766', color:'#fff', fontSize:12, fontWeight:'bold', paddingLeft:5, paddingRight:5, borderColor:'#666'}:{borderColor:'#666', fontSize:12, paddingLeft:5, paddingRight:5, height:25}} >Learning Mode</ToggleButton>
													<ToggleButton value="advance" disabled={selfAssessorFormType==='advance'} style={selfAssessorFormType==='advance'?{height:25, backgroundColor:'#f09766', color:'#fff', fontSize:12, fontWeight:'bold', paddingLeft:5, paddingRight:5, borderColor:'#666', marginLeft:-10}:{borderColor:'#666', fontSize:12, paddingLeft:5, paddingRight:5, height:25, marginLeft:-10}} >Competitive Mode</ToggleButton>
												</ToggleButtonGroup>
												</Stack>
											</Box>
										:null}	 */}

											{/* {(progressBarFlag && progressBarFlag>0)?
												<Box mt={1} >
													<h3 style={{textAlign:'center', color:progressBarColor}}>{progressBar}%</h3>
													<BorderLinearProgress variant="determinate" value={progressBar} />
													{progressBarRemarks?<div style={{textAlign:'center', fontSize:10}}>{progressBarRemarks}</div>:null}
												</Box>
											:null}
 */}
											<Box>
												{(localStorage.getItem('selfAssessorFormType')==='advance')?
												<Box mt={2}>
													{/* <Box component="form" noValidate >										
															<TextField onChange={event => setTotalQuestion(event.target.value)} value={totalQuestion} style={{marginTop:15,marginRight:'4%'}} type="number" min="10" max="30" label="Total number of question" variant="standard" fullWidth />
															<TextField onChange={event => setTotalTime(event.target.value)} value={totalTime} style={{marginTop:15,marginRight:'4%'}} type="number" defaultValue="30" min="5" max="30" label="Total time for Test (minute)" variant="standard" fullWidth />
															<TextField onChange={event => setMarksCorrectAnswer(event.target.value)} value={marksCorrectAnswer} style={{marginTop:15,marginRight:'4%'}} type="number" defaultValue="1" min="1" max="50" step="0.1" label="Marks for correct answer" variant="standard" fullWidth />
															{(examType && examType==='objective')?<> 
															<TextField onChange={event => setMarksIncorrectAnswer(event.target.value)} value={marksIncorrectAnswer} style={{marginTop:15,marginRight:'4%'}} type="number" defaultValue="0" min="0" max="50" step="0.1" label="Marks for incorrect answer" variant="standard" fullWidth />
															<TextField onChange={event => setMarksNotAttempted(event.target.value)} value={marksNotAttempted} style={{marginTop:15,marginRight:'4%'}} type="number" defaultValue="0" min="0" max="50" step="0.1" label="Marks for questions not attempted" variant="standard" fullWidth />
															</>:null}
													</Box> */}
												</Box>
												:
												<Box mt={2} >
													{/* <span className="headingTwoo" >{searchQuery?<span>{searchFlag+': '+searchQuery}</span>:<span style={{color:'red'}} >Select topic to begin</span>}</span> */}
													{/* {searchQuery?<div style={{color:'#2b568d',fontWeight:'bold',fontSize:14}}>Pool Size: {availableTotalQuestion} Questions</div>:null} */}
													{/* {searchQuery?<div style={{color:'#fb630f',fontWeight:'bold',fontSize:12}}>{searchFlag==='Keyword'?<>Session Size: {totalQuestionKwd} Questions</>:<>Session Size: {totalQuestion} Questions</>}</div>:null} */}

												</Box>
												}

												

												{(availableTotalQuestion!=null && availableTotalQuestion>0)?<>	
													{(validityExpired===true)?      
														<Box mt={2} >
														<h4 style={{textAlign:'center',color:'#FF0000',fontWeight:'bold'}}>
															{(organisationName && organisationName.length>0)?<>{organisationName}'s</>:null} validity has been finished. Renew your account to continue your practice.
														</h4> 
														</Box>     
													:null}
													<Box>
													{(validityExpired===true)?
														<div style={{textAlign:'center'}}>
															<Button title="Renew Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{marginBottom:5,textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Renew Now</Button>
														</div>
														:
														<Button onClick={() => {startMyTest()}} size="small" variant="contained" color="primary" >Start Learning</Button>
													}
													</Box>
												</>:null}
												{(localStorage.getItem('selfAssessorFormType')==='beginner')?
												<Box mt={1} className="selectTopicTxtt" >
													<p>General Instructions</p>
													<ul style={{marginLeft:12}}>
													<li>Try to answer all the questions.</li>
													<li><span style={{color:'red'}}>Do not guess.</span> In case you don't know the answer click <span style={{color:'green'}}>HELP</span></li>	
													<li>First search the answer from your books. Then ask Tony AI</li>
													<li>If your doubts are still not cleared SKIP a question. ETL Teachers will clear the doubts.</li>	
													<li>Each learning session will have different set  questions.</li>
													<li>We recommend to move to competitive mode only if the learning session progress bar is green.</li>
													</ul>
												</Box>
												:null}

                                                  <TutorialButton/>
											</Box>
										</Box>
									</Box>
								</Box>
							</Grid>
							:null}
						</Grid>
					</Box>



				

				</Box>
				</main>

				<div className="student_panel_mobile_display">
					{searchQuery ? (
						<BottomDrawer
							searchQuery={searchQuery}
							examType={examType}
							totalQuestion={totalQuestion}
							totalTime={totalTime}
							marksCorrectAnswer={marksCorrectAnswer}
							marksIncorrectAnswer={marksIncorrectAnswer}
							marksNotAttempted={marksNotAttempted}
							setTotalQuestion={setTotalQuestion}
							setTotalQuestionKwd={setTotalQuestionKwd}
							setTotalTime={setTotalTime}
							handleSelftTestOption={handleSelftTestOption}
							selftTestOptions={selftTestOptions}
							selftTestOptionIndex={selftTestOptionIndex}
							setMarksCorrectAnswer={setMarksCorrectAnswer}
							setMarksIncorrectAnswer={setMarksIncorrectAnswer}
							setMarksNotAttempted={setMarksNotAttempted}
							organisationName={organisationName}
							availableTotalQuestion={availableTotalQuestion}
							upgradeNow={upgradeNow}
							startMyTest={startMyTest}
							validityExpired={validityExpired}
							progressBarFlag={progressBarFlag}
							progressBar={progressBar}
							progressBarRemarks={progressBarRemarks}
							selfAssessorFormType={selfAssessorFormType}
							prntSelfAssessorFormType={setSelfAssessorFormType}
						/>
					) : (
						<></>
					)}
				</div>
									
				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>			

				<DialogTestStart testType={testType} toCallDeleteCurrentStartNew={deleteCurrentStartNew} toCallContinueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} ref={childRefStartTest}  />		

				
				{etlStudentObj?.firstTimeUser === 1 && !ftue && popup1 ? (
					<NewTutorialButton />
				) : (
					<></>
				)}
									

			</div>
		);
 
}